import { Button } from 'antd';
import CSVReader, { IFileInfo } from 'react-csv-reader';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './CsvReader.styles';

import { Icon } from '@/components/Icon';

const parserOptions = {
  header: true,
  dynamicTyping: true,
  skipEmptyLines: true,
  transformHeader: (header: string) => header.toLowerCase().replace(/\W/g, '_')
};

type Props = {
  fileLoaded: (data: { [key: string]: string }[], dataInfo: IFileInfo) => void;
  disabled: boolean;
};

export const CsvReader: React.FC<Props> = ({ fileLoaded, disabled }) => {
  const { t } = useTranslation('ManagerQuizzesTranslations');
  return (
    <Button>
      <CSVReader
        inputStyle={{ display: 'none' }}
        accept="text/csv"
        disabled={disabled}
        label={
          <Wrapper>
            <Icon i="Upload" />
            <div>{t('UPLOAD_FILE')}</div>
          </Wrapper>
        }
        onFileLoaded={fileLoaded}
        parserOptions={parserOptions}
      />
    </Button>
  );
};
